import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { OnboardTeacherBody } from "@shared-kernel/application/ports/shared/shared-repository";

export const onboardTeacher = createApiThunk<void, OnboardTeacherBody>(
  "users/onboardTeacher",
  async (body, { extra: { sharedRepository } }) => {
    return sharedRepository!.onboardTeacher(body);
  },
);

export const resetOnboardTeacher = createAction("users/resetOnboardTeacher");
